import { useEffect, useState } from "react";
import { downloadAccrualMSXL, getAccrualsTableData } from "../../Repository/AccrualsRepository";
import { ErrorMessage, InfoMessage, SuccessMessage } from "../../Utils/Utils";
import { Button, DatePicker, Form, Input, Spin, Table, Tooltip } from "antd";
import {  SearchOutlined } from "@ant-design/icons";
import  "../../GlobalCss/SPF/AccrualsMfTable.css"
import { title } from "process";


const AccrualsMfTable = () => {

    const [form] = Form.useForm();

    const [griddata, setGriddata] = useState([]);
    const [tableLoader, setTableLoader] = useState(false);
    const [syncSpin, setSyncSpin] = useState(false);
    const [searchRow, setSearchRow] = useState("");
    const [fromDate, setFromDate] = useState();
    const [toDate, setTodate] = useState();
    const isEditing = (record) => record.ID === editingKey;
    const [editingKey, setEditingKey] = useState("");
    const [newFrom, setNewFrom] = useState("");
    const [newTo, setNewTo] = useState("");

    // useEffect(() => {
    //     callGetGridData();
    // }, [])

    const callGetGridData = async (from,to) => {
        try{
            setTableLoader(true);
            const res = await getAccrualsTableData(from, to);
            if(res != null && res.length > 0){
                // Format the weekend date before setting grid data
                const formattedData = res.map((item) => ({
                    ...item,
                    Date: item.Date
                        ? new Date(item.Date).toLocaleDateString("en-US", {
                            year: "numeric",
                            month: "2-digit",
                            day: "2-digit",
                        })
                    : null, 
                }));
                setGriddata([...formattedData]);
            } else {
                setGriddata([])
            }
            setTableLoader(false);
        }catch {
            ErrorMessage("Cannot able to get data");
            setTableLoader(false);
        }

    }
    const EditableCell = ({
        editing,
        dataIndex,
        title,
        inputType,
        record,
        index,
        children,
        ...restProps
    }) => {
    const inputNode = <Input />;
        return (
          <td {...restProps}>
            {editing ? (
              <Form.Item
                name={dataIndex}
                style={{
                  margin: 0,
                }}
              >
                {inputNode}
              </Form.Item>
            ) : (
              children
            )}
          </td>
        );
    };
    const filterProps = () => ({
        filteredValue: [searchRow],
        onFilter: (value, record) => {
          return (
            String(record.Client_Name)
              .toLowerCase()
              .includes(String(value).toLowerCase()) ||
            String(record.Associate_Name)
              .toLowerCase()
              .includes(String(value).toLowerCase())
          );
        },
    });

    const columns = [
        {
            title: "Client Name",
            key: "Client_Name",
            dataIndex: "Client_Name",
            width: 150,
            editable: true,
            ellipsis: true,
        },
        {
            title: "Date",
            key: "Date",
            dataIndex: "Date",
            width: 150,
            editable: true,
            ellipsis: true,
        },
        {
            title: "Associate Name",
            key: "Associate_Name",
            dataIndex : "Associate_Name",
            width: 150,
            editable : true,
            ellipsis: true,
            ...filterProps(),
            render: (text, record, index) => (
                <div style={{ whiteSpace: "normal", lineHeight: "1.3" }}>{text}</div>
            ),
        },
        {
            title : "Rate Type",
            key: "Rate_Type",
            dataIndex: "Rate_Type",
            width: 150,
            editable: true,
            ellipsis: true,

        },
        {
            title : "Hours",
            key: "Hours",
            dataIndex: "Hours",
            width: 150,
            editable: true,
            ellipsis: true,
            
        },
        {
            title : "Bill Rate",
            key: "Bill_Rate",
            dataIndex: "Bill_Rate",
            width: 150,
            editable: true,
            ellipsis: true,
        },
        {
            title : "Gross Amount",
            key: "Gross_Amount",
            dataIndex: "Gross_Amount",
            width: 150,
            editable: true,
            ellipsis: true,
        },
        {
            title : "Discount",
            key: "Discount",
            dataIndex: "Discount",
            width: 150,
            editable: true,
            ellipsis: true,
        },
        {
            title : "Calculation",
            key: "Calculation",
            dataIndex: "Calculation",
            width: 150,
            editable: true,
            ellipsis: true,
        },
        {
            title : "Net Amount",
            key: "Net_Amount",
            dataIndex: "Net_Amount",
            width: 150,
            editable: true,
            ellipsis: true,
        },
        {
            title: "Timesheet Status",
            key:"Timesheet_Status",
            dataIndex: "Timesheet_Status",
            width: 200,
            editable: true,
            ellipsis: true,
        },
        {
            title: "File Number",
            key: "File_Number",
            dataIndex : "File_Number",
            width : 150,
            editable : true,
            ellipsis : true,
        },
        {
            title: "Text",
            key: "Text",
            dataIndex : "Text",
            width : 150,
            editable : true,
            ellipsis : true,
        },
        {
            title: "File",
            key: "File",
            dataIndex : "File",
            width : 150,
            editable : true,
            ellipsis : true,
        },
        {
            title: "Gross",
            key: "Gross",
            dataIndex : "Gross",
            width : 150,
            editable : true,
            ellipsis : true,
        },
        {
            title: "VMS FEE",
            key: "VMS_FEE",
            dataIndex : "VMS_FEE",
            width : 150,
            editable : true,
            ellipsis : true,
        },
        {
            title: "Notes",
            key:"Notes",
            dataIndex : "Notes",
            width :150,
            editable : true,
            ellipsis : true
        }

    ]

    const mergedColumns = columns.map((col) => {
        if (!col.editable) {
          return col;
        }
        return {
          ...col,
          onCell: (record) => ({
            record,
            inputType: "text",
            dataIndex: col.dataIndex,
            title: col.title,
            editing: isEditing(record),
          }),
        };
    });

    const downloadAccrualsMsfile = async () =>{
        try{
            const res = await downloadAccrualMSXL(griddata);
            if(res === "downloaded"){
                SuccessMessage("Download Sucessfully !");
            } 
        }
        catch{
            ErrorMessage("Cannot able to download, please try again");
        }
    }
    const callCalendar = (e) => {
        if(e !== null) {
            if(e[0] !== null && e[1] !== null){
                const sample = new Date(e[0]);
                const sample1 = new Date(e[1]);
                var newD = parseInt(sample.getMonth() + 1 ) + '/' + parseInt(sample.getDate()) + '/' + parseInt(sample.getFullYear());
                var newD1 = parseInt(sample1.getMonth() + 1) + '/' + parseInt(sample1.getDate()) + '/' + parseInt(sample1.getFullYear());
                setFromDate(newD);
                setTodate(newD1); 
            }
        }
        else{
            setFromDate();
            setTodate();
        }
    }

    const changeFromDate = (e) => {
        let sample = new Date(e);
        if(e !== null){
            setFromDate(sample);
        } else {
            setTodate();
        }

        // Format date  as MM/DD/YYYY
        let newD = `${String(sample.getMonth() + 1).padStart(2, '0')}/${String(sample.getDate()).padStart(2, '0')}/${sample.getFullYear()}`;
        setNewFrom(newD);

        if(toDate !== undefined && sample < toDate && e !== null ){
            callGetGridData(newD, newTo);
        } else if (toDate !== undefined && sample > toDate && e !== null ){
            InfoMessage("From date should not be greater than To date");
        }
    };

    const changeToDate = (e) => {
        let sample = new Date(e);
        if(e !== null){
            setTodate(sample);
        } else {
            setTodate();
        }

        let newD = `${String(sample.getMonth() + 1).padStart(2, '0')}/${String(sample.getDate()).padStart(2, '0')}/${sample.getFullYear()}`;
        setNewTo(newD);

        if(fromDate !== undefined && fromDate < sample && e !== null){
            callGetGridData(newFrom,newD);
        } else if( fromDate !== undefined && fromDate > sample && e !== null){
            InfoMessage("To date should be greater than from date");
        }
    };

    return(
        <>
            <div style={{margin: 20 }}>
                <div style={{marginBottom : 10}} className="Arrucalsgmf-div">
                    <div style={{width:"90%", display:"flex"}}>
                        <Input
                            placeholder="Search Associate Name \ Client Name"
                            className="MFAccruals-searchrow"
                            // style={{ borderColor: "#3B52DF", color: "#3B52DF" }}
                            onChange={(e) => setSearchRow(e.target.value)}
                            allowClear
                            suffix={
                              <SearchOutlined
                                style={{ color: "#7185FF", justifyContent: "space-between" }}
                              />
                            }
                        />
                        <DatePicker
                            className="accrulas-datepickers"
                            onChange={changeFromDate}
                            placeholder="Form Date"
                            format={"MM-DD-YYYY"}
                        />
                        <DatePicker
                            className="accrulas-datepickers"
                            onChange={changeToDate}
                            placeholder="To date"
                            format={"MM-DD-YYYY"}
                        />
                    </div>
                    <div>
                        
                    </div>

                    <div style={{ display: "flex", alignItems: "center" }}>
                        <Button onClick={downloadAccrualsMsfile}  className="dwld-invoice">
                             Download .CSV
                        </Button>
                    </div> 
                </div>
                <div 
                    className={
                        griddata.length > 0 ? "Accruals-table-class" : "Accruals-empty-table"
                    }
                />
                {tableLoader ? (
                    <Spin tip="Loading...">
                        <Form form={form} component= {false}>
                            <Table
                                className="ten99-table"
                                rowClassName="editable-row"
                                columns={mergedColumns}
                                dataSource={griddata}
                                components={{ body: { cell: EditableCell } }}
                                bordered
                                scroll={{ x: "max-content", y: 400 }}
                            />{""}
                        </Form>{""}
                    </Spin>
                ) : griddata.length > 0 ? (
                    <Form form={form} component={false}>
                        <Table
                            className="ten99-table"
                            rowClassName="editable-row"
                            columns={mergedColumns}
                            dataSource={griddata}
                            components={{ body: { cell: EditableCell } }}
                            bordered
                            scroll={{ x: 1500, y: 400 }}
                        />
                    </Form>
                ) : (
                    <Form form={form} component={false}>
                        <Table
                            className="ten99-table"
                            rowClassName="editable-row"
                            columns={mergedColumns}
                            dataSource={griddata}
                            components={{ body: { cell: EditableCell } }}
                            bordered
                            scroll={{ x: 400, y: 400 }}
                        />
                    </Form>
                )}
            </div>
        </>
    )

}
export default AccrualsMfTable;